import React from 'react';
import { useQuery } from '@apollo/client';
import { preofferSelectedQuery } from '@fingo/lib/apollo/cache/localQuery';
import { preofferSelected } from '@fingo/lib/apollo/reactive-variables/invoices';
import { PREOFFERS, TODAY, TWO_MONTHS_AGO } from '@fingo/lib/constants';
import FingoMainViewV2 from '@fingo/lib/components/layout/FingoMainViewV2';
import ShoppingCartSearchHeader from '@fingo/lib/components/headers/ShoppingCartSearchHeader';
import { AVAILABLE_FACTORING } from '@fingo/lib/graphql';
import { useSelectedCompany } from '@fingo/lib/hooks';
import NoRowsGeneric from '@fingo/lib/components/text/NoRowsGeneric';
import InvoicesActions from '../components/invoices/InvoicesActions';
import { COLUMNS, SUBTITLE, TITLE } from '../constants/invoices';
import InvoicesSummary from '../components/invoices/InvoicesSummary';

const Invoices = () => {
  const { data: { selectedPreofferIds } } = useQuery(preofferSelectedQuery);
  const selectedCompany = useSelectedCompany();

  const isInvoiceCompliant = (invoice) => {
    const { complianceStatus } = invoice;
    if (!complianceStatus) return false;

    return (
      complianceStatus.debtorApproved === true
      && complianceStatus.withinAvailableDays === true
      && complianceStatus.hasPaymentComplement === false
    );
  };

  const hasRedStatus = (invoice) => {
    const { complianceStatus } = invoice;
    if (!complianceStatus) return true;

    return (
      complianceStatus.debtorApproved === false
      || complianceStatus.withinAvailableDays === false
      || complianceStatus.hasPaymentComplement === true
    );
  };

  const isRowSelectable = ({ row }) => (
    row.preofferSelectable?.selectable
    && isInvoiceCompliant(row)
    && !hasRedStatus(row)
  );

  const filterCompliantInvoices = (data) => {
    if (!data?.invoices?.edges) return data;

    const filteredEdges = data.invoices.edges.filter((edge) => isInvoiceCompliant(edge.node));

    return {
      ...data,
      invoices: {
        ...data.invoices,
        edges: filteredEdges,
        totalCount: filteredEdges.length,
      },
    };
  };
  return (
    <FingoMainViewV2
      id="invoices"
      apolloQuery={{
        query: AVAILABLE_FACTORING,
        orderBy: { field: 'pk', sort: 'desc' },
        variables: {
          availableForFinancing: 'AVAILABLE',
          companyId: selectedCompany?.id,
          preoffer_Preofferevaluationrequest_Isnull: true,
          dateIssued_Gte: TWO_MONTHS_AGO.format('YYYY-MM-DD'),
          dateIssued_Lte: TODAY.format('YYYY-MM-DD'),
        },
        transformData: filterCompliantInvoices,
      }}
      slots={{
        header: ShoppingCartSearchHeader,
        summary: InvoicesSummary,
        actions: InvoicesActions,
      }}
      slotProps={{
        headerProps: {
          title: TITLE,
          subtitle: SUBTITLE,
          shoppingCartType: PREOFFERS,
          shoppingCartItems: selectedPreofferIds,
        },
        summaryProps: { open: selectedPreofferIds.length !== 0 },
        tableProps: {
          columns: COLUMNS,
          checkboxSelection: true,
          disableSelectionOnClick: true,
          onSelectionModelChange: (ids) => {
            preofferSelected(ids);
          },
          noRowsMessage: NoRowsGeneric,
          selectionModel: selectedPreofferIds,
          isRowSelectable,
        },
      }}
    />
  );
};

export default Invoices;
